import * as actionTypes from "../actions/actionTypes";

const initialState = {
  loading: null,
  error: null,
  success: null,
  couponDetails:{
  },
  rewardAndCouponUserList:[],
//   bussinessRatingListing: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.START_REWARD_ACTION:
      return {
        ...state,
        loading: true,
        error: null
      };
    case actionTypes.REWARD_ACTION_FAIL:
      return {
        ...state,
        loading: null,
        error: action.message,
        success: null,
      }
      case actionTypes.CREATE_COUPON_REWARD_SUCCESS:
      return {
        ...state,
        loading: null,
        error: null,
        success: action.message,
        couponDetails:action.details
      }
    case actionTypes.FETCH_REWARD_USER_LIST_SUCCESS:
      return {
        ...state,
        loading: null,
        rewardAndCouponUserList: action.listing,
        error: null,
        success: action.message,
      }
      case actionTypes.UPDATE_REWARD_SUCCESS:
      return {
        ...state,
        loading: null,
        rewardAndCouponUserList: action.listing,
        error: null,
        success: action.message,
      }
    default:
      return state;
  }
};

export default reducer;
